export const extractData = ({ data }) => data;
